export const PAGE_HEIGHT = 'calc(100vh - 128px)';

export enum Messages {
  Required = 'Pflichtfeld',
  InvalidDateFormat = 'Invalid date format',
  GeneralError = 'Es ist ein Fehler aufgetreten',
  ActionSuccessfully = 'Aktion Erfolgreich ausgeführt',
  ReloadSuccessfully = 'Daten wurden erfolgreich aktualisiert',
}
